import VadImage from "vadimages-nextjs-image-optimizer";
import {EVENT_COPY} from "../content";
import {Blobs} from "./Blobs";
import css from "../mjbc-2026.module.scss";

const IMG = '/images/mjbc-2026';

interface NamePanelProps {
    /** Rank and person, kept apart so the sheet can break between them. */
    parts: readonly [string, string];
    onContinue: () => void;
}

/** Frame 5: the cyan nameplate carrying the partner name, gated on the CTA. */
export default function NamePanel({parts: [rank, person], onContinue}: NamePanelProps) {
    return (
        <section className={css.panel}>
            <p className={css.intendedFor}>{EVENT_COPY.intendedFor}</p>
            {/* Two spans, not one string: mobile breaks after the rank so the
                name and surname stay together on the second line, and desktop
                leaves them inline as frame 05 draws them. */}
            <p className={css.nameplate}>
                {/* One wrapper, and it matters: .nameplate is a flex row, so
                    bare spans became flex ITEMS and sat side by side however
                    the sheet set their display. Inside this they are ordinary
                    inline text again, which is what lets mobile break after
                    the rank. */}
                <span className={css.nameplateText}>
                    <span className={css.nameplateRank}>{rank}</span>
                    {person === '' ? null : <> <span>{person}</span></>}
                </span>
            </p>
            <p className={css.chosen}>
                {EVENT_COPY.chosen[0]}<br/>{EVENT_COPY.chosen[1]}
            </p>
            <button type="button" className={css.ctaButton} onClick={onContinue}>
                <Blobs/>
                <span>{EVENT_COPY.briefingCta[0]}<br/>{EVENT_COPY.briefingCta[1]}</span>
                <VadImage src={`${IMG}/icon-arrow-right.svg`} alt="" width={40} height={35}/>
            </button>
        </section>
    );
}
